import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  QueryList
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import {
  EventSearchType,
  ProgramTypesGUID,
  EventStatus,
  EventStatusNames
} from '../../../../models/_enum-collections';
import { CustomerPreviewInput } from '../../../../models/customer-validation-preview-input.model';
import { EventPreviewInput } from '../../../../models/event-preview-input.model';
import { EventDocument } from '../../../../models/event-registration-document.model';
import { EventRegistrationModel } from '../../../../models/event-registration.model';
import { EventSearchFilterRequest } from '../../../../models/event-search-filter-request.model';
import { AppConstants } from '../../../common/app-constants';
import { CommonSharedModule } from '../../../common/shared.module';
import { LocalStorageService } from '../../../services/local-storage-service';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';
import { EditEventComponent } from '../edit-event/edit-event.component';
import { EventPreviewComponent } from '../../preview/event-preview/event-preview.component';
import { CustomerValidationPreviewComponent } from '../../preview/customer-validation-preview/customer-validation-preview.component';
import { EventDashboardService } from '../../../services/event-dashboard.service';
import { EventTypeService } from '../../../services/event-type.service';

@Component({
  selector: 'app-event-table',
  templateUrl: './event-table.component.html',
  styleUrls: ['./event-table.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    EditEventComponent,
    EventPreviewComponent,
    CustomerValidationPreviewComponent
  ]
})
export class EventTableComponent implements OnInit {
  showTargetProduct = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: LocalStorageService,
    private eventDashboardService: EventDashboardService,
    private eventTypeService: EventTypeService,
    private osmService: OsmosisEditService
  ) {}

  @Input() loading!: boolean;
  scrollableCols = new Array<any>();
  loadingIcon = 'fa-circle-o-notch';
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  tblPageNumber = 1;
  totalRecords!: number;
  loadEditComponent!: boolean;
  editNav = false;
  eventIdPassToChild!: number;
  display!: boolean;
  showFullScreen!: boolean;
  canShowEventPreviewModel!: boolean;
  @Input() eventSearchType!: EventSearchType;
  eventEditInput!: EventRegistrationModel;
  eventsDisplayed!: EventRegistrationModel[];
  eventSearchSubscription!: Subscription;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  delayedLoadSearchContent!: Function;
  eventSearchFilterRequest!: EventSearchFilterRequest;
  eventStatusDropdownItems: SelectItem[] = [];
  l1InternalStatusDropdownItems: SelectItem[] = [];
  l2InternalStatusDropdownItems: SelectItem[] = [];
  targetProductDropdownItems: SelectItem[] = [];
  eventTypeDropdownItems: SelectItem[] = [];
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChild('editNavChild', { static: false })
  editNavChild!: EditEventComponent;

  @ViewChildren('tak') components!: QueryList<MultiSelect>;

  customerValidationPreviewInput!: CustomerPreviewInput;
  eventPreviewInput!: EventPreviewInput;

  canShowCustomerPreviewModel!: boolean;
  customerValidationReviewEventSearchType: EventSearchType =
    EventSearchType.CustomerValidationReview;
  invoiceDocReviewEventSearchType: EventSearchType =
    EventSearchType.InvoiceDocReview;
  rollCallReviewEventSearchType: EventSearchType =
    EventSearchType.RollCallReview;
  eventsProgram: string = ProgramTypesGUID.Events;

  ngOnInit() {
    this.loadEventStatusDropdownItems();
    this.getL1InternalStatusList();
    this.getL2InternalStatusList();
    this.getEventTypeList();
    this.getTargetProductList();

    this.delayedLoadSearchContent = _.debounce(this.loadEvents, 1000);

    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.eventSearchFilterRequest = {
      pageSize: this.dataViewRecsPerPage,
      page: this.tblPageNumber,
      programTypeGuid: ProgramTypesGUID.Events
    };

    this.loadEvents({ first: 0 });

    this.scrollableCols = [
      { field: 'eventKey', header: 'Event Id' },
      { field: 'requestDate', header: 'Request Date' },
      { field: 'eventStatusName', header: 'Event Status' },
      { field: 'partnerOrgName', header: 'Partner Name' },
      { field: 'partnerMpnid', header: 'MPN ID' },
      { field: 'l1InternalStatus', header: 'L1 Internal Status' },
      { field: 'eventType', header: 'Event Sub Type' },
      { field: 'eventTargetProductName', header: 'Target Product' }
    ];
    this.localStorage.setFullscreenMode(true);
    this.showFullScreen = this.localStorage.getFullscreenMode();
  }

  loadEventStatusDropdownItems(): void {
    const statusKeys = Object.keys(EventStatus).filter(
      x => !isNaN(parseInt(x, 0))
    );

    for (const key of statusKeys) {
      const itm: SelectItem = {
        label: EventStatusNames[EventStatus[parseInt(key, 0)]],
        value: EventStatusNames[EventStatus[parseInt(key, 0)]]
      };
      this.eventStatusDropdownItems.push(itm);
    }
  }

  getL1InternalStatusList() {
    this.osmService.getL1InternalStatusDropDown().subscribe(PTList => {
      for (const item of PTList) {
        const fl1InternalStatusDrpdwn: SelectItem = {
          label: item.l1internalStatus,
          value: item.l1internalStatus
        };
        this.l1InternalStatusDropdownItems.push(fl1InternalStatusDrpdwn);
      }
    });
  }

  getL2InternalStatusList() {
    this.osmService.getL2InternalStatusDropDown().subscribe(PTList => {
      for (const item of PTList) {
        const fl1InternalStatusDrpdwn: SelectItem = {
          label: item.l2internalStatus,
          value: item.l2internalStatus
        };
        this.l2InternalStatusDropdownItems.push(fl1InternalStatusDrpdwn);
      }
    });
  }

  getEventTypeList() {
    this.eventTypeService
      .getRegisteredEventTypes(ProgramTypesGUID.Events)
      .subscribe(PTList => {
        for (const item of PTList) {
          const eventTypeDrpdwn: SelectItem = {
            label: item,
            value: item
          };
          this.eventTypeDropdownItems.push(eventTypeDrpdwn);
        }
      });
  }
  getTargetProductList() {
    this.eventDashboardService
      .getEventsTargetProductList()
      .subscribe(PTList => {
        for (const item of PTList) {
          const targetProductDropDown: SelectItem = {
            label: item.description,
            value: item.description
          };
          this.targetProductDropdownItems.push(targetProductDropDown);
        }
      });
  }

  loadEvents(event: LazyLoadEvent): void {
    if (event) {
      this.pageChange(event);
    } else {
      this.pageChange({ first: 0 });
    }

    this.loading = true;
    if (this.eventSearchSubscription) {
      this.eventSearchSubscription.unsubscribe();
    }

    switch (this.eventSearchType) {
      case EventSearchType.AllEvents:
        this.eventSearchSubscription = this.eventDashboardService
          .getAllEvents(this.eventSearchFilterRequest)
          .subscribe(data => {
            this.eventsDisplayed = data.results;
            this.totalRecords = data.rowCount;
            this.loading = false;
          });
        break;
      case EventSearchType.CustomerValidationReview:
        this.eventSearchSubscription = this.eventDashboardService
          .getAwaitingCustomerValidationEvents(this.eventSearchFilterRequest)
          .subscribe(data => {
            this.eventsDisplayed = data.results;
            this.totalRecords = data.rowCount;
            this.loading = false;
          });
        break;
      case EventSearchType.InvoiceDocReview:
        this.eventSearchSubscription = this.eventDashboardService
          .getAwaitingInvoiceDocReviewEvents(this.eventSearchFilterRequest)
          .subscribe(data => {
            this.eventsDisplayed = data.results;
            this.totalRecords = data.rowCount;
            this.loading = false;
          });
        break;
      case EventSearchType.CustomerSurveyReview:
        this.eventSearchSubscription = this.eventDashboardService
          .getAwaitingCustomerSurveyReviewEvents(this.eventSearchFilterRequest)
          .subscribe(data => {
            this.eventsDisplayed = data.results;
            this.totalRecords = data.rowCount;
            this.loading = false;
          });
        break;
    }
  }

  export() {
    this.router.navigate(['download-csv'], { relativeTo: this.route });
  }

  pageChange(e) {
    const calc = e.first / this.dataViewRecsPerPage + 1;

    this.tblPageNumber = calc || 1;
    this.eventSearchFilterRequest.page = this.tblPageNumber;
  }

  onSearchInput(event, dt) {
    if (event.inputType === 'insertText') {
      if (event.data.trim() !== '') {
        dt.filterGlobal(event.target.value, 'contains');
      }
    } else {
      dt.filterGlobal(event.target.value, 'contains');
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.pageChange({ first: 0 });
  }

  searchOrFilterEngagements() {
    this.eventSearchFilterRequest.page = 1;
    if (this.dt) {
      this.dt.first = this.eventSearchFilterRequest.page;
    }

    if (
      this.eventSearchFilterRequest.eventKey != undefined &&
      this.eventSearchFilterRequest.eventKey.toString() === ''
    ) {
      this.eventSearchFilterRequest.eventKey = undefined;
    }

    if (
      this.eventSearchFilterRequest.partnerOrgName != undefined &&
      this.eventSearchFilterRequest.partnerOrgName.toString() === ''
    ) {
      this.eventSearchFilterRequest.partnerOrgName = undefined;
    }

    if (
      this.eventSearchFilterRequest.partnerMpnid != undefined &&
      this.eventSearchFilterRequest.partnerMpnid.toString() === ''
    ) {
      this.eventSearchFilterRequest.partnerMpnid = undefined;
    }

    if (
      this.eventSearchFilterRequest.fiscalYear != undefined &&
      this.eventSearchFilterRequest.fiscalYear.toString() === ''
    ) {
      this.eventSearchFilterRequest.fiscalYear = undefined;
    }

    this.delayedLoadSearchContent();
  }

  get currentPageInfo(): string {
    if (this.totalRecords === 0) {
      return 'No Record Found';
    } else if (this.totalRecords > 0 && this.tblPageNumber === 1) {
      return `Showing 1 - ${this.eventsDisplayed.length} of ${this.totalRecords} Records`;
    } else if (this.totalRecords > 0 && this.tblPageNumber > 1) {
      const rangeStart =
        (this.tblPageNumber - 1) * this.dataViewRecsPerPage + 1;
      let rangeEnd = 0;

      if (this.tblPageNumber * this.dataViewRecsPerPage >= this.totalRecords) {
        rangeEnd = this.totalRecords;
      } else if (
        this.tblPageNumber * this.dataViewRecsPerPage <
        this.totalRecords
      ) {
        rangeEnd = this.tblPageNumber * this.dataViewRecsPerPage;
      }

      return `Showing ${rangeStart} - ${rangeEnd} of ${this.totalRecords} Records`;
    }
    return '';
  }

  reset() {
    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.filter('', 'l1InternalStatus', 'in');
      this.dt.filter('', 'eventStatusName', 'in');
      this.dt.filter('', 'partnerOrgName', 'in');
      this.dt.filter('', 'partnerMpnid', 'in');
      this.dt.filter('', 'eventKey', 'in');
      this.dt.filter('', 'eventType', 'in');
      this.dt.filter('', 'requestDate', 'in');
      this.dt.filter('', 'eventTargetProductName', 'in');
      this.dt.reset();
    }

    this.eventSearchFilterRequest = {
      pageSize: this.dataViewRecsPerPage,
      page: this.tblPageNumber
    };

    this.display = false;
  }

  editRequestDetails(id: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.eventIdPassToChild = id;
    this.eventEditInput = this.eventsDisplayed.filter(
      x => x.eventRegistrationId === id
    )[0];
  }

  previewFile(eventRegistrationId) {
    this.eventPreviewInput = {
      isSOWPreview: false,
      isDAPOETemplate: false,
      eventId: eventRegistrationId,
      eventIdList: this.eventsDisplayed.map(event => event.eventRegistrationId),
      previewFileIndex: 0,
      isPoeInvoicePreview: false,
      isRollCallPreview: false,
      isSKUPurchaseTrialPreview: false,
      invoiceFile: {} as EventDocument,
      rollCallFile: {} as EventDocument,
      skuPurchaseTrialCallFile: {} as EventDocument,
      daPOETemplate: {} as EventDocument,
      documentType: ''
    };

    this.eventPreviewInput.eventId = eventRegistrationId;
    this.eventPreviewInput.eventIdList = this.eventsDisplayed.map(
      event => event.eventRegistrationId
    );

    if (this.eventSearchType === EventSearchType.InvoiceDocReview) {
      this.eventPreviewInput.isPoeInvoicePreview = true;
      this.eventPreviewInput.isRollCallPreview = false;
    } else if (this.eventSearchType === EventSearchType.RollCallReview) {
      this.eventPreviewInput.isPoeInvoicePreview = false;
      this.eventPreviewInput.isRollCallPreview = true;
    }

    this.canShowEventPreviewModel = true;
  }

  closePreview() {
    this.canShowEventPreviewModel = false;
  }

  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullScreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullScreen);
  }

  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
    this.setEventStatus();
  }

  async setEventStatus() {
    const event = await this.loadEventInfo();
    if (event) {
      const eventIndex = this.eventsDisplayed.indexOf(
        this.eventsDisplayed.find(
          event =>
            event.eventRegistrationId ===
            this.eventEditInput.eventRegistrationId
        ) as EventRegistrationModel
      );
      this.eventsDisplayed[eventIndex] = event;
    }
  }

  async loadEventInfo() {
    return await this.eventDashboardService
      .getEventRegistration(this.eventEditInput.eventRegistrationId)
      .toPromise();
  }

  sort(columnKey: string) {
    const column = this.scrollableCols.find(x => x.field === columnKey);

    column.descending =
      column.descending === undefined ? true : !column.descending;

    const columnIndex = this.scrollableCols.indexOf(column);

    this.scrollableCols[columnIndex] = column;

    this.eventSearchFilterRequest.sortField = column.field;
    this.eventSearchFilterRequest.sortOrderDescending = column.descending;
    this.loadEvents({} as LazyLoadEvent);
  }

  showCustomerPreview(eventRegistrationId) {
    this.canShowCustomerPreviewModel = true;
    this.customerValidationPreviewInput = {
      eventId: eventRegistrationId,
      eventIdList: this.eventsDisplayed.map(event => event.eventRegistrationId)
    };
  }

  closeCustomerPreview() {
    this.canShowCustomerPreviewModel = false;
  }
}
